import Vue from 'vue';
import {Component, watch} from 'vue-property-decorator';
import './navbar.scss';
import {Route} from 'vue-router';
import * as _ from 'lodash';

@Component({
  template: `
<nav class="navbar">
  <transition :name="hideBackInitial ? 'none' : 'fade'">
    <span v-if="!hideBack" class="back-button" @click="back"></span>
  </transition>
  <transition name="fade">
    <span v-if="!hideSteps"  class="steps">Step {{ step }} of 3</span>
  </transition>
</nav>
`
})
export class NavbarComponent extends Vue {
  step: number = 0;

  backButtonVisible: boolean = true;

  hideBack: boolean = true;
  hideSteps: boolean = true;
  hideBackInitial: boolean = true;

  routesSequence: Route[] = [];

  mounted() {
    this.step = this.$route.meta.step;
    if (this.$route.path == '/') {
      this.hideBack = true;
      this.hideSteps = false;
      this.hideBackInitial = true;
    } else {
      this.hideBack = this.$route.meta.hideBack;
      this.hideSteps = this.$route.meta.hideSteps;
    }
  }

  @watch('$route')
  routeChanged(to: Route, from: Route) {
    if (!(to.query.routerback)) {
      this.routesSequence.push(from);
    }
    this.step = to.meta.step;
    this.hideBack = to.meta.hideBack;
    this.hideSteps = to.meta.hideSteps;
    this.hideBackInitial = to.meta.hideBackInitial;
  }

  back() {
    let lastRoute;

    if (this.$route.meta.alwaysBackTo) {
      const index = _.indexOf(_.map(this.routesSequence, 'path'), this.$route.meta.alwaysBackTo);
      if (index !== -1) {
        lastRoute = this.routesSequence[index];
        this.routesSequence.length = index;
      }
    } else {
      lastRoute = this.routesSequence.pop()
    }

    if (lastRoute) {
      this.$router.push({ path: lastRoute.path, query: _.extend({}, lastRoute.query, { routerback: 'true' }), params: lastRoute.params});
    } else {
      console.warn('Cannot go back: no route history, have you reloaded the browser? Going to email-entry');
      this.$router.push('email-entry');
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/navbar/navbar.ts